import { useMutation } from 'react-query';
import {
  generateDirectSalePaymentReceipt,
  generateDirectSaleSeller,
  generateDirectSaleSellerSynthetic,
  generateDirectSaleSummaryPeriod,
  generateDirectSaleSummarySituation,
} from './DirectSale.service';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';

export function useDirectSaleSellerReportData() {
  const mutation = useMutation(generateDirectSaleSeller, {
    onSuccess() {
      notification.success({
        message: 'Relatório gerado com sucesso',
        description: 'Relatório de venda direta gerado com sucesso!',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}

export function useDirectSaleSellerSyntheticReportData() {
  const mutation = useMutation(generateDirectSaleSellerSynthetic, {
    onSuccess() {
      notification.success({
        message: 'Relatório gerado com sucesso',
        description: 'Relatório de venda direta gerado com sucesso!',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}

export function useDirectSaleSummaryPeriodReportData() {
  const mutation = useMutation(generateDirectSaleSummaryPeriod, {
    onSuccess() {
      notification.success({
        message: 'Relatório gerado com sucesso',
        description: 'Relatório de venda direta gerado com sucesso!',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}

export function useDirectSaleSummarySituationReportData() {
  const mutation = useMutation(generateDirectSaleSummarySituation, {
    onSuccess() {
      notification.success({
        message: 'Relatório gerado com sucesso',
        description: 'Relatório de venda direta gerado com sucesso!',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}

export function useDirectSalePaymentReceipt() {
  return useMutation(generateDirectSalePaymentReceipt, {
    onSuccess() {
      notification.success({
        message: 'Recibo gerado com sucesso',
        description: 'Recibo de pagamento da venda direta gerado com sucesso!',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
